module.exports = __webpack_public_path__ + "static/media/avon-logo-rebranding.8f97899c.svg";